<template>
    <div>
        <div class="col-md-12 mt-3">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="col-md-12 mt-3">
            <div class="row col-md-12 justify-content-center mt-5" v-if="listaMesesAbiertos != 0">
                <md-table md-card md-fixed-header v-model="listaMesesAbiertos">
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell :md-label="labels.fecha" class="border">{{ item.fecha }}</md-table-cell>
                        <md-table-cell :md-label="labels.detalle" class="border text-left">{{ formatMes(item.fecha) }}</md-table-cell>
                    </md-table-row>
                </md-table>
            </div>
            <div v-else>
                <h5>{{ labels.noRow }}</h5>
            </div>
        </div>
    </div>
</template>

<script>
import ContratoCierre from '../../services/ContratoCierre'
export default {
    name : 'ConsultaMesesAbiertos',
    data : () => ({
        listaMesesAbiertos : []
    }),
    computed : {
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Meses abiertos',
                    fecha : 'Año / Mes',
                    detalle : 'Detalle',
                    noRow : 'No hay registros'
                }
            }else{
                return {
                    title : 'Open months',
                    fecha : 'Year / Month',
                    detalle : 'Detail',
                    noRow : 'There are no records'
                }
            }
        }
    },
    methods:{
        formatMes(anioMes){
            const input = anioMes;
            const [year, month] = input.split('-');

            const meses = [
                'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
            ];

            const mesNombre = meses[parseInt(month) - 1];

            const resultado = `${mesNombre} ${year}`;
            return resultado
        }
    },
    mounted(){
        ContratoCierre.getMesesAbiertos()
        .then((result) => {
            // console.log(result.data.lstFechaOpen);
            this.listaMesesAbiertos = result.data.lstFechaOpen
        }).catch((err) => {
            console.log(err);   
        });
    }
}
</script>

<style>

</style>